import Vue from 'vue'
import { Tabs,TabPane,InputNumber,Tooltip,Table,TableColumn,RadioGroup,Radio,Select,Option,Tag,DropdownItem,DropdownMenu,Dropdown,Breadcrumb,BreadcrumbItem,Button,Input,FormItem,Form,Message,Menu,Submenu,MenuItem,MenuItemGroup,MessageBox,Switch } from 'element-ui'

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;

Vue.use(Button)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Tag)
Vue.use(Select)
Vue.use(Option)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(InputNumber)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Switch)

